﻿import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederOblDto from '../Models/VeilederOblDto';

const uniHoysk = 'a1-uniHoysk';
const folkehogskole = 'a2-folkehogskole';
const annenHoyere = 'a3-annenHoyere';
const uniHoyUtl = 'a4-uniHoyUtl';
const annenHoyereUtl = 'a5-annenHoyereUtl';

const aValg: RadioButtonValgModel<VeilederOblDto>[] = [
    {
        id: 'a1',
        value: uniHoysk,
        tekst: 'valgUniversitetOgHoyskoleNorge',
    },
    {
        id: 'a2',
        value: folkehogskole,
        tekst: 'valgFolkehogskole',
    },
    {
        id: 'a3',
        value: annenHoyere,
        tekst: 'valgAnnenHoyereUtdanning',
    },
    {
        id: 'a4',
        value: uniHoyUtl,
        tekst: 'valgUniversitetOgHoyskoleUtland',
    },
    {
        id: 'a5',
        value: annenHoyereUtl,
        tekst: 'valgAnnenHoyereUtdanningUtland',
    },
];

export default {
    a1_uniHoysk: uniHoysk,
    a2_folkehogskole: folkehogskole,
    a3_annenHoyere: annenHoyere,
    a4_uniHoyUtl: uniHoyUtl,
    a5_annenHoyereUtl: annenHoyereUtl,
    aValg,
};
